<template>
    <PopupRouterView :showLeftIcon="true" label="Part Destination Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="partdestination"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="partDestinationInput">


        <b-card header="Part Destination" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId" :isRequired="true" :state="validateState('customerId')" :errorMessage="getErrorMessage(errorMessage.customerId, 'customerId')"   :selected="model.customer != null ? model.customer.code : ''" @input="getCustomers" @change="onCustomerChange" :isUpdatable ="null" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
						<app-label label-cols-lg="12" size="sm" label="Is Direct Delivery" :model="(model.part != null) ? model.part.isDirectDelivery : null"  />
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Destination" id="fieldset-destination" size="sm" :model.sync="model.destinationId" :isRequired="true" :state="validateState('destinationId')" :errorMessage="getErrorMessage(errorMessage.destinationId, 'destinationId')"   :selected="model.destination != null ? model.destination.code : ''" @input="getCustomers"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedDestination" />
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor Subcontract" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"  :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" />
						<app-label label-cols-lg="12" size="sm" label="Vendor Name" :model="(model.vendor != null) ? model.vendor.name : null"  />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartDestination from '@/models/PartDestination/PartDestination';
import PartDestinationFilter from '@/filters/PartDestination/PartDestinationFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppLabel from '@/components/AppLabel';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			customerId: {required},
			partId: {required},
			destinationId: {required},
			//vendorId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				customerId: { required : "Customer is Required."},
				partId: { required : "Part is Required."},
				destinationId: { required : "Destination is Required."},
				//vendorId: { required : "Vendor Subcontract is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {
        customerId: null,
        partId: null,
        destinationId: null,
        vendorId: null
      },
			filterPartDestination : null,
			currentPartDestinationPage : 1,
			partDestinationPageSize: 10,
			sortByPartDestination: '',
			sortDescPartDestination: '',
			customers: [],
			isCustomerComboLoading: false,
			parts: [],
			isPartComboLoading: false,
			partState: false,
			vendors: [],
			isVendorComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getPartDestination : async function(id) {
			this.isBusy = true;
			PartDestination.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.vendorId != null) {
					promises.push(
						this.getVendor(this.model.vendorId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartDestination = true;
			this.filterPartDestination.id = this.modelId;
			PartDestination.downloadDataDetail(this, this.filterPartDestination).then(result => {
				this.isDownloadPartDestination = false;
			}).catch(error => { this.isDownloadPartDestination = false; })
		},
		getPartDestinations : async function(input) {
			let filter = new PartDestinationFilter();
			if (input != undefined) {
				filter.Destination = input;
			}
			this.isPartDestinationComboLoading = true;
			PartDestination.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partDestinations = result.data
				}
				this.isPartDestinationComboLoading = false;
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedCustomer(item) {
			if(item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onCustomerChange : async function() {
			this.model.partId = null;
			this.model.part = null;

			let item = this.model.customerId;
			let customerObj = this.customers.filter(function(customer){ return customer.id == item; });
			this.model.customer = customerObj.length > 0 ? customerObj[0] : null;
			this.getParts();
			this.getPartByCustomer();
		},
		getPartByCustomer : async function(input) {
			this.partState = false;
			this.$forceUpdate();

			let filter = new PartFilter();
			filter.customerId = this.model.customerId;
			if (input != undefined) {
				filter.partNumber = input;
			}
			if (filter.customerId === undefined || filter.customerId === null || filter.customerId === '') {
				this.parts = [];
			} else {
				Part.getList(this, filter, null, 0, 10)
					.then(result => {
						this.parts = [];
						if (result != null) {
							this.parts = result.data
						}
					})
					.catch(error => {
						this.parts = [];
					});
			}

			this.partState = true;
			this.$forceUpdate();
		},

		getParts : async function(input) {
			await this.getPartByCustomer(input);
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDestination(item) {
			if(item == undefined || item == null) {
				this.model.destinationId = null;
				this.model.destination = null;
			} else {
				this.model.destinationId = item.id;
				this.model.destination = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendor : async function(id) {
			Vendor.getData(this, id).then(result => {
				this.model.vendor = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partDestinationInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PartDestination.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partdestinationindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						PartDestination.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partdestinationindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartDestination.updateData(this, model, id)
					.catch((error) => {
						this.getPartDestination(id);
					});
				}
			});
		},
		onHidden() {
			this.getPartDestinations();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterPartDestination = new PartDestinationFilter();
		//this.getCustomers();
		//this.getParts();
		//this.getVendors();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartDestination(id);
			} else {
				this.modelId = id;
				this.getPartDestination(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
